export const total = (map) =>
  Array.from(map.values()).reduce((acc, item) => (acc += item.count), 0);
